<template>
    <client-only>
        <ModalWrapper v-model="modal" max-width="800">
            <template v-slot:title>
                {{ $t('comments_modal_title') }}
            </template>
            <template v-slot:content>
                <v-textarea v-model="comments" :placeholder="$t('type_here')" rows="1" hide-details />
            </template>
            <template v-slot:btns>
                <v-btn :loading="isLoading" :disabled="isLoading" variant="flat" data-cy="save" @click="saveComments">
                    {{ $t('save') }}
                </v-btn>
            </template>
        </ModalWrapper>
    </client-only>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {EventBus, SHOW_SERVICE_COMMENTS_EDITING_MODAL} from '@/utils/event-bus'
    import {clone} from '@/utils/helpers'
    import {appInstance} from '@/utils/app-accessor'

    @Component({
        components: {},
    })
    export class ServiceCommentsModal extends Vue {
        modal = false
        isLoading = false
        service = null
        orderId = null
        comments = null

        mounted() {
            EventBus.$on(SHOW_SERVICE_COMMENTS_EDITING_MODAL, this.showModal)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_SERVICE_COMMENTS_EDITING_MODAL, this.showModal)
        }

        showModal({service, orderId}) {
            this.service = service
            this.orderId = orderId
            this.comments = service.comments ? clone(service.comments) : ''
            this.modal = true
        }

        async saveComments() {
            this.isLoading = true
            try {
                const productType = this.service.processId.split('/').splice(2, 2)[0]
                const processId = this.service.processId.split('/').splice(2, 2)[1]

                const res = await appInstance.$api.serviceComments.put(
                    {productType, processId},
                    {comment: this.comments}
                )

                if (this.$conf.public.reservationReport && this.service.processId) {
                    await this.markAsNotSentToSupplier()
                }

                if (res.comment || res.comment === '') {
                    runtimeStore.UPDATE_SERVICE_COMMENT({
                        serviceId: this.service.serviceId,
                        comment: this.comments,
                    })
                }
            } catch (e) {
                if (e.errors?.length) {
                    const firstToken = e.errors[0].token.split(' ').join('_').toLowerCase()

                    if (firstToken === 'max_length_of_comment_is_1024') {
                        this.$toast.error(this.$t(`api_error_token.${firstToken}`))
                    } else this.$toast.error(this.$t('error_message.save_error'))
                } else this.$toast.error(this.$t('error_message.save_error'))
            } finally {
                this.isLoading = false
                this.modal = false
            }
        }

        async markAsNotSentToSupplier() {
            await this.$api.orders.put(this.orderId, {
                servicesInfo: [
                    {
                        processId: this.service.processId,
                        serviceSentToSupplier: false,
                    },
                ],
            })
            await runtimeStore.refreshOrder()
        }
    }

    export default ServiceCommentsModal
</script>
